import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';
import { colors } from '../../utils';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      padding: theme.spacing(2),
      display: 'flex',
      overflow: 'auto',
      flexDirection: 'column'
    },
    formControl: {
      margin: theme.spacing(1)
    },
    tableHeader: {
      background: colors.defaultGrey,
      position: 'sticky',
      top: 0,
      zIndex: 10
    }
  })
);
